module.exports = __webpack_public_path__ + "icons/original/small/small-a2.e58c4d7d4ca282f01f1842de56fcc204.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-a2.png
// module id = nVYH
// module chunks = app